import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../service/utils.service';
import { GlobalConfig } from '../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { SpinnerService } from '../../service/spinner.service';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  packageId: any = '';
  apiUrl: any = '';
  forgotForm: FormGroup;
  formErrors: any;
  submitted: Boolean = false;
  isEdit: Boolean = false;
  constructor(
    private route: ActivatedRoute,
    private servicesComponent: AuthService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager,
    private spinnerService: SpinnerService
  ) {
  }

  forgot: any = { userName: '' };

  ngOnInit() {
  }


  forgotPassword(form) {
    this.submitted = false;
    if (form.valid) {
      this.spinnerService.displayLoader(true);
      this.servicesComponent.forgotPassword(this.forgot.userName)
        .then((response: any) => {
          this.spinnerService.displayLoader(false);
          if (response.error == true) {
            this.toastr.error(response.message);
          }
          else {
            this.toastr.success('your password has been sand to your email id.', 'Success!');
            this.forgot.userName = "";
          }

        })
        .catch(error => {
          this.spinnerService.displayLoader(false);
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    } else {
      this.submitted = true;
    }
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/auth/forgot-password/forgot-password.component.ts